import usePlan from "hooks/usePlan";
import useQuery from "hooks/useQuery";

/**
 * Planes del catálogo (`GET /plans`) que incluyen `featureKey`, de menor a mayor rank.
 * Es la misma matriz que aplica el gate del api, así que la pill del modal dice lo que
 * se puede editar en Igor sin tocar el front. Misma query que la pantalla de Planes
 * (usePlanes): comparten caché.
 *
 * Sólo con el enforcement de planes prendido (`enforced` de /access). Apagado, la
 * matriz comercial todavía no es la que se vende y el modal usa el copy fijo de copy.js
 * (decisión de Fran, 2026-10-29).
 *
 * Vacío mientras carga, si falla o si ningún plan trae la feature (ej. el techo de
 * agendas, que es un límite y no una feature): el modal cae al copy fijo.
 */
export default function useAvailablePlans(featureKey) {
  // `|| {}`: en tests de pantallas usePlan suele estar automockeado (devuelve undefined).
  const { enforced } = usePlan() || {};
  const catalog = useQuery("plans", { staleTime: 60000, retry: false, timeout: 10000, enabled: !!enforced });
  if (!enforced) return [];
  return [...(catalog.data?.plans || [])]
    .sort((a, b) => a.rank - b.rank)
    .filter((plan) => plan.features?.[featureKey]?.enabled);
}
